import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const PublicLayout = ({ children }) => {
  return (
    <div className="bg-cream min-h-screen">
      <Header />
      {/* Spacer for fixed header */}
      <div className="h-[78px] md:h-[92px]" aria-hidden />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
